import {createRouter, createWebHistory} from 'vue-router'
import NotFoundView from "@/views/NotFoundView.vue";
import platForm from "@/views/platform/index.vue"

const routes = [
    {
        path: '/',
        name: 'home',
        redirect: {
            name: 'AboutInnost'
        }
    },
    {
        path: `/:pathMatch(.*)`,
        component: NotFoundView
    },
    {
        path: `/about/innost`,
        name: 'AboutInnost',
        meta: {
            headerText: 'INNOST 소개'
        },
        component: () => import('@/views/about/IntroduceView.vue')
    },
    {
        path: `/about/facility`,
        name: 'AboutFacility',
        meta: {
            headerText: '시설소개'
        },
        component: () => import('@/views/about/FacilityView.vue')
    },
    {
        path: `/about/location`,
        name: 'AboutLocation',
        meta: {
            headerText: '위치안내'
        },
        component: () => import('@/views/about/LocationView.vue')
    },
    // {
    //     path: `/book`,
    //     name: 'BookList',
    //     meta: {
    //         headerText: '도서대출 이용현황'
    //     },
    //     component: () => import('@/views/book/ListView.vue')
    // },
    // {
    //     path: `/book/:id(\\d+)`,
    //     name: 'BookDetail',
    //     meta: {
    //         headerText: '도서대출 이용현황'
    //     },
    //     component: () => import('@/views/book/DetailView.vue')
    // },
    {
        path: `/notice/:mngId`,
        name: 'NoticeDetail',
        meta: {
            headerText: ''
        },
        component: () => import('@/views/notice/DetailView.vue')
    },
    {
        path: `/business/:mngId`,
        name: 'BusinessDetail',
        meta: {
            headerText: ''
        },
        component: () => import('@/views/business/DetailView.vue')
    },
    {
        path: `/article/:nttId/:bbsId`,
        name: 'ArticleDetail',
        meta: {
            headerText: ''
        },
        component: () => import('@/views/article/DetailView.vue')
    },
    {
        path: `/our-startup`,
        name: 'OurStartup',
        meta: {
            headerText: ''
        },
        component: () => import('@/views/ourstartup/index.vue')
    },
    {
        path: `/our-startup/about/:entId`,
        name: 'OurStartupAbout',
        meta: {
            tab: 'about',
            headerText: ''
        },
        component: () => import('@/views/ourstartup/IntroView.vue')
    },
    {
        path: `/our-startup/publicity/:entId`,
        name: 'OurStartupPublicity',
        meta: {
            tab: 'publicity',
            headerText: ''
        },
        component: () => import('@/views/ourstartup/ListVIew.vue')
    },
    {
        path: `/our-startup/publicity/:entId/:nttId`,
        name: 'OurStartupDetail',
        meta: {
            headerText: ''
        },
        component: () => import('@/views/ourstartup/DetailView.vue')
    },
    {
        path: `/platform/`,
        name: 'platform',
        meta: {
            headerText: 'PLATFORM SERVICE'
        },
        redirect: "/platform/cloud",
        component: platForm,
        children: [
            {
                path: `cloud`,
                name: 'PlatformCloud',
                component: () => import('@/views/platform/CloudView.vue')
            },
            {
                path: `studio`,
                name: 'PlatformStudio',
                component: () => import('@/views/platform/StudioView.vue')
            },
            {
                path: `equip`,
                name: 'PlatformEquip',
                component: () => import('@/views/platform/EquipmentView.vue')
            },
            {
                path: `consult`,
                name: 'PlatformConsult',
                component: () => import('@/views/platform/ConsultingView.vue')
            }
        ]
    },
    {
        path: '/terms/:termId',
        name : 'TermDetail',
        component: () => import('@/views/terms/DetailView.vue')
    },
    {
        path: '/bill/:billId',
        name : 'BillDetail',
        component: () => import('@/views/bill/DetailView.vue')
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    strict: true,
    base: '/web-view',
    scrollBehavior(to,
                   from,
                   savePosition
    ) {
        if (savePosition) {
            return savePosition
        } else {
            return {x: 0, y: 0}
        }
    }
})


export default router
